import axios from 'axios';
import apiUrl from 'config/api';

import {
  FETCH_RESULTS,
  FETCH_RESULTS_SUCCESS,
  FETCH_RESULTS_FAIL,
  FETCH_RESULT,
  FETCH_RESULT_SUCCESS,
  FETCH_RESULT_FAIL
} from 'config/types';

export const fetchResults = ({onSuccess}) => dispatch => {
  dispatch({ type: FETCH_RESULTS });

  return axios({
    method: 'GET',
    url: `${apiUrl}/results`,
  })
    .then(({ data }) => dispatch({ type: FETCH_RESULTS_SUCCESS, payload: data }))
    .then(onSuccess)
    .catch(error => dispatch({ type: FETCH_RESULTS_FAIL, error }));
};

export const fetchResult = (id, {onSuccess}) => dispatch => {
  dispatch({ type: FETCH_RESULT });

  return axios({
    method: 'GET',
    url: `${apiUrl}/results/${id}`,
  })
    .then(({ data }) => dispatch({ type: FETCH_RESULT_SUCCESS, payload: data }))
    .then(onSuccess)
    .catch(error => dispatch({ type: FETCH_RESULT_FAIL, error }));
};